import { Outlet, matchPath, useLocation } from 'react-router-dom'

import { CompensationsRootPageDocument } from 'generated/resources/graphql'

import AuthorizeUser from 'modules/core/components/AuthorizeUser'
import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import { useQuery } from 'modules/core/hooks/useQuery'

import CollectionsBootstrap from 'modules/compensations/lib/CollectionsBootstrap'

const CompensationsRootPage = () => {
  const { company } = useCurrentSession()
  const { navigation } = useNavigation()
  const location = useLocation()
  const { data, error, loading } = useQuery(CompensationsRootPageDocument, {
    variables: {
      companyId: company.id,
    },
  })
  const compensationsEnabled =
    data?.compensations._policies.sidebarSeeCompensationsTopLevelItem.can ?? false

  if (loading || error || !data) return null

  const employeeUpdatesPattern = navigation.compensations.employeeUpdates.fullPath()
  const isEmployeeUpdatesRoute =
    matchPath({ path: `${employeeUpdatesPattern}/*`, end: false }, location.pathname) ||
    matchPath({ path: employeeUpdatesPattern, end: true }, location.pathname)

  if (isEmployeeUpdatesRoute) {
    return <Outlet context={{ compensationsEnabled }} />
  }

  return (
    <AuthorizeUser authorizeFn={() => compensationsEnabled}>
      <Outlet context={{ compensationsEnabled }} />
    </AuthorizeUser>
  )
}

const RootPage = () => {
  return (
    <CollectionsBootstrap>
      <CompensationsRootPage />
    </CollectionsBootstrap>
  )
}

export default RootPage
